import { API_URL } from '../../../utils/config';

export const LOGGED_IN_USER_URL = `${API_URL}/employeeReg/logged`;
export const LOG_IN_USER_URL = `${API_URL}/employeeLogin`;
export const GET_ROLES_URL = `${API_URL}/roles`;
export const SIGN_UP_USER_URL = `${API_URL}/employeeReg`;
export const FORGOT_PASSWORD_URL = `${API_URL}/staff/forgotPassword`;
export const RESET_PASSWORD_URL = `${API_URL}/staff/reset`;
